import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactBar from "@/components/feature/ContactBar";
import HeroSection from "@/components/feature/HeroSection";
import AboutSection from "@/components/feature/AboutSection";
import ServicesSection from "@/components/feature/ServicesSection";
import AdvantagesSection from "@/components/feature/AdvantagesSection";
import PartnersSection from "@/components/feature/PartnersSection";
import TestimonialsSection from "@/components/feature/TestimonialsSection";
import LeadCaptureSection from "@/components/feature/LeadCaptureSection";
import ContactSection from "@/components/feature/ContactSection";
import SEOMeta from "@/components/base/SEOMeta";

const siteUrl = import.meta.env.VITE_SITE_URL || "";
const currentDate = new Date().toISOString();

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "FinancialService",
  "@id": `${siteUrl}/#organization`,
  "name": "RCRED Negócios Financeiros",
  "alternateName": "RCRED",
  "description": "Soluções em crédito para realizar o sonho da casa própria e alavancar seus investimentos com as melhores taxas do mercado. Especialistas em financiamento imobiliário, Home Equity e consórcio em São Paulo.",
  "url": siteUrl,
  "telephone": "+5511985860949",
  "email": "contato@rcrednegocios.com.br",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "São Paulo",
    "addressRegion": "SP",
    "addressCountry": "BR"
  },
  "areaServed": {
    "@type": "City",
    "name": "São Paulo"
  },
  "sameAs": [
    "https://www.instagram.com/rcrednegocios",
    "https://www.facebook.com/rcrednegocios"
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "18:00"
  },
  "priceRange": "$$",
  "currenciesAccepted": "BRL",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Serviços Financeiros",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Financiamento Imobiliário",
          "description": "Simulação e assessoria para financiamento de imóveis com as melhores taxas do mercado."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Home Equity",
          "description": "Utilize o valor do seu imóvel quitado para obter crédito com taxas reduzidas."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Consórcio",
          "description": "Planeje a compra do seu imóvel de forma programada e sem juros com consórcio imobiliário."
        }
      }
    ]
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  "name": "RCRED Negócios Financeiros",
  "url": siteUrl,
  "description": "Soluções em crédito para realizar o sonho da casa própria e alavancar seus investimentos com as melhores taxas do mercado.",
  "inLanguage": "pt-BR",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${siteUrl}/?s={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        const navbarHeight = 80;
        const y = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEOMeta jsonLd={[localBusinessSchema, websiteSchema]} id="schema-jsonld" />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <AdvantagesSection />
        <PartnersSection />
        <TestimonialsSection />
        <LeadCaptureSection />
        <ContactSection />
      </main>
      <Footer />
      <ContactBar />
      {/* Espaço para a barra de contato fixa no mobile */}
      <div className="h-12 md:h-0"></div>
    </div>
  );
}